<template>
  <section
    class="fixed inset-0 z-[100000000] flex justify-center items-center bg-black bg-opacity-60 backdrop-blur-sm"
  >
    <section
      class="relative flex flex-col justify-between bg-navy-bg text-white rounded-lg shadow-xl w-full max-w-lg md:max-w-2xl lg:max-w-3xl xl:max-w-4xl max-h-[95vh] min-h-[20em] min-w-[90vw] md:min-w-[30em] p-4"
    >
      <header class="flex justify-end pb-2">
        <AppButton
          v-bind:visibility="true"
          left_icon="fa-regular fa-circle-xmark fa-xl"
          emitType="close"
          @close="$emit('close')"
          :width="20"
          :height="20"
          :padding="'0px'"
          class="hover:text-blue-safe"
        />
      </header>
      <div class="flex flex-col gap-4 overflow-auto min-h-[10em]">
        <!-- <aside v-if="propsData.sideBar">
          <ol>
            <li
              v-for="item in propsData.entity"
              @click="setEntityData(item, propsData.entity.indexOf(item))"
              :class="currentEntity == propsData.entity.indexOf(item) ? 'active' : ''"
            >
              {{ item[0] == "t" && item[1] == "p" ? item.slice(2) : item }}
            </li>
          </ol>

          <ul>
            <li>Imprimir</li>
            <li>outros</li>
          </ul>
        </aside> -->

        <section v-if="!pagination" class="content w-full">
          <AppTable
            :status="entityResponseStatus"
            :noClose="true"
            :simple="true"
            :visibility="true"
            :show="true"
            :table_data="entityData"
            :table_title="
              propsData.title
                ? propsData.title
                : customEtityName(propsData.entity[currentEntity], true)
            "
            @row-dClicked="ConfirmDialog"
            @row-clicked="selectRowData"
            @close="null"
          />
        </section>
        <section v-else class="content  w-full">
          <AppTablePagination
            :visibility="true"
            :show="true"
            :table_title="propsData.title? propsData.title
                : customEtityName(propsData.entity[currentEntity], true)
            "
            @row-clicked="selectRowData"
            @close="null"
            class="h-full"
            @row-dClicked="ConfirmDialog"
            :show_export="showExport"
            
            :page_display="10"
            :refresh="refresh"
            @refreshed="refresh = false"
            :urlString="propsData.entity[currentEntity]"
            
            :multiSelect="{
              show: multiSelectOptions.enabled,
              isActive: multiSelectOptions.enabled,
              buttons: {
                add: {
                  show: multiSelectOptions.show_btn,
                  enabled: true,
                  text: '',
                  color: '#ff9b05',
                  icon: 'fa-solid fa-pen-to-square',
                  emit: 'send-selected-rows',
                },
                delete: {
                  show: multiSelectOptions.show_btn,
                  enabled: false,
                  text: '',
                  color: 'red',
                  icon: 'fa-solid fa-trash-alt',
                  emit: 'remove-selected-rows',
                },
              },
            }"
            
            @multiRow-clicked="selectMultiRowData"
          />
        </section>
      </div>
      <div class="footer pt-6 flex flex-col md:flex-row justify-between gap-4">
        <section class="left flex flex-wrap gap-2">
          <button
            v-for="item in propsData.buttons"
           class="p-2 text-xs rounded-md bg-blue-safe"
            @click="dinamicButton(item)"
          >
            {{ item }}
          </button>
        </section>
        <section class="right flex gap-2">
          <button
            class="p-2 text-xs rounded-md bg-red-600"
            @click="CancelDialog"
          >
            Cancelar
          </button>
          <button
             class="p-2 text-xs rounded-md bg-blue-safe"
            @click="ConfirmDialog"
          >
            Confirmar
          </button>
        </section>
      </div>
      <!-- <ConfirmDialog @response="responseConfirm"/> -->
    </section>
  </section>
</template>

<script>
import AppButton from "@/components/updated/button.vue";
import AppTable from "@/components/tables/TecnicoTable.vue";
import axios from "axios";
import ConfirmDialog from "@/components/dialog/confirmDialog.vue";
import AppTablePagination from "@/components/tablePagination/tablePaginationDark.vue";
import { toast } from "vue3-toastify";

export default {
  components: {
    AppButton,
    AppTable,
    
    ConfirmDialog,
    AppTablePagination,
  },
  props: {
    propsData: {
      type: Object,
      default: () => {
        return {
          entity: ["equipamento"],
          buttons: [],
          sideBar: true,
          multi: false,
          specialQuery: null,
          title: null,
          // currentEntity: 'equipamento',
        };
      },
    },
    multiSelectOptions: {
      type: Object,
      default: { enabled: false, show_btn: false },
    },
    pagination: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showExport: false,
      isOpen: true,
      entityResponseStatus: 200,
      entityData: [],
      refresh: false,
      baseURl: process.env.VUE_APP_URL_BASE,
      currentEntity: 0,
      selectedRow: { index: 0, data: {} },
      selectedRow2: [],
      sendMultiData: false,
    };
  },
  methods: {
    responseConfirm(response) {
      if (response) {
        console.log("Confirmado");
      } else {
        console.log("Cancelado");
      }
    },

    ConfirmDialog() {
      //J...06_02_2025
      if (
        !this.selectedRow2 ||
        (Array.isArray(this.selectedRow2) && this.selectedRow2.length === 0) ||
        (!this.propsData.multi && !this.selectedRow2[0])
      ) {
        toast.info("Por favor, selecione uma linha antes de confirmar!", {
          position: "top-right",
          timeout: 3000,
        });
        return;
      }

      if (this.propsData.multi) {
        let customizedEntityData = [];
        for (const key in this.selectedRow2) {
          customizedEntityData.push({
            [this.propsData.entity[key]]: this.selectedRow2[key],
          });
        }

        // if()
        this.$emit("returnData", customizedEntityData);
      } else {
        if (this.sendMultiData) {
          console.log("Multi data: ", this.selectedRow2);
          if (this.propsData.title) {
            this.$emit("returnData", {
              [this.propsData.title]: this.selectedRow2,
            });
          } else
            this.$emit("returnData", {
              [this.propsData.entity[0]]: this.selectedRow2,
            });
        } else if (this.propsData.title) {
          this.$emit("returnData", {
            [this.propsData.title]: this.selectedRow2[0],
          });
        } else
          this.$emit("returnData", {
            [this.propsData.entity[0]]: this.selectedRow2[0],
          });
      }

      this.$emit("close");
    },

    CancelDialog() {
      // if(this.selectedRow2.length > 0){

      // }else{
      this.selectedRow2 = [];
      this.$emit("close");

      // }
    },

    closeDialog() {
      this.isOpen = false;
    },

    selectRowData(row) {
        console.log("Row: ", row);
      this.sendMultiData = false;
      this.selectedRow = { index: this.currentEntity, data: row };
      this.selectedRow2[this.currentEntity] = row;

      // console.table(this.selectedRow2);
    },
    selectMultiRowData(rows) {
      console.log("Rows: ", rows);
      this.sendMultiData = true;

      this.selectedRow2 = rows;
      // console.table(this.selectedRow2);
    },

    setEntityData(entity, index) {
      this.currentEntity = index;
      this.fetchAll(entity);
    },

    customEtityName(entity, plural = false) {
      let final = "";
      if (plural) {
        final = "s";
      }

      if (entity[0] == "t" && entity[1] == "p" && entity[3]) {
        // return entity[2].toUpperCase() + entity.slice(3) + final;
        return "Tipos de " + entity[2].toUpperCase() + entity.slice(3);
      } else {
        return entity[0].toUpperCase() + entity.slice(1);
      }
    },

    async fetchAll(entity) {
      let url = `${this.baseURl}/api/v1/${entity}/`;

      try {
        // const specialQuery = this.propsData?.specialQuery;
        // const entity = this.propsData?.entity;
        // const currentEntity = this.currentEntity;

        // if(this.propsData.queryParams[[this.propsData.entity[this.currentEntity]]]){
        try {
          let newUrl = `${this.baseURl}/api/v1/${entity}/?${
            this.propsData.queryParams[
              [this.propsData.entity[this.currentEntity]]
            ]
          }`;
          url = newUrl;
        } catch (err) {
          // url = `${this.baseURl}/api/v1/${entity}/`;
          console.log("Nao tem query");
        }
        // console.log('Query: => ',this.propsData.specialQuery);

        console.log("URL aqui: ", url);
        // if(this.propsData.specialQuery[[this.propsData.entity[this.currentEntity]]]){

        // if(this.propsData.specialQuery[[this.propsData.entity[this.currentEntity]]] != null && this.propsData.specialQuery[[this.propsData.entity[this.currentEntity]]] != undefined){

        if (
          this.propsData.specialQuery &&
          this.propsData.specialQuery[[entity]]
        ) {
          if (this.propsData.specialQuery[[entity]] == null) {
            console.log("Special query nulo");
            return;
          }

          let newUrlurl = `${this.baseURl}/api/v1/${
            this.propsData.specialQuery[
              [this.propsData.entity[this.currentEntity]]
            ]
          }`;
          url = newUrlurl;
          // console.log('Veio com o special query');
        } else {
          // console.log('Nao veio com o special query');
        }

        let res = await axios.get(url);

        this.entityData = res.data.data;
        this.entityResponseStatus = res.status;
        // console.log('Dados de {'+entity+'}: ',this.entityData);
      } catch (err) {
        console.log("URL: ", url);
        console.log("Erro ao fazer fetch no dialog de {" + entity + "}: ", err);
      }
    },
  },
  mounted() {
    // this.makeElementDraggable(document.querySelector('.wrap-content'));

    let header = document.querySelector(".wrap-content header");
    let content = document.querySelector(".wrap-content");

    let isDragging = false;
    let offsetX, offsetY;

    // header.addEventListener("mousedown", (e) => {
    //   isDragging = true;
    //   offsetX = e.clientX - content.offsetLeft;
    //   offsetY = e.clientY - content.offsetTop;
    //   content.style.width = `${content.offsetWidth}px`; // Fixar a largura
    //   content.style.height = `${content.offsetHeight}px`; // Fixar a altura
    // });

    // header.addEventListener('mouseup', () => {
    //     header.style.cursor = 'grabbing';
    // });

    document.addEventListener("mousemove", (e) => {
      if (isDragging) {
        content.style.left = `${e.clientX - offsetX}px`;
        content.style.top = `${e.clientY - offsetY}px`;
      }
    });

    document.addEventListener("mouseup", () => {
      isDragging = false;
    });
  },
  created() {
    if(!this.pagination){
      this.fetchAll(this.propsData.entity[0]);
    }
    this.propsData.sideBar = this.propsData.multi;
  },

  watch: {
    pagination: {
      handler() {
        this.refresh = true;
      },
    },
  },
};
</script>

<style scoped>
/* Main overlay */
.fixed.inset-0 {
  background: rgba(0, 0, 0, 0.6) !important;
  backdrop-filter: blur(4px);
  z-index: 100000000;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Dialog box */
.bg-navy-bg {
  background: #181a20 !important;
  color: #fff;
  border-radius: 0.75rem;
  box-shadow: 0 8px 32px 0 #00000055;
  max-width: 90vw;
  min-width: 90vw;
  max-height: 95vh;
  min-height: 20em;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

/* Responsive width for dialog */
@media (min-width: 768px) {
  .bg-navy-bg {
    min-width: 30em;
    max-width: 48em;
  }
}

/* Header */
header.flex.justify-end.pb-2 {
  padding-bottom: 0.5rem;
}

/* Loader */
.flex.justify-center.items-center.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}

/* Table/content area */
.content.w-full {
  width: 100%;
  background: transparent;
}

/* Footer */
.footer.pt-6 {
  padding-top: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
@media (min-width: 768px) {
  .footer.pt-6 {
    flex-direction: row;
    justify-content: space-between;
    gap: 1rem;
  }
}

/* Footer buttons */
.footer .left button,
.footer .right button {
  padding: 0.5rem 1.2rem;
  font-size: 0.85rem;
  border-radius: 0.375rem;
  font-weight: 500;
  transition: background 0.2s, color 0.2s;
  outline: none;
  border: none;
  cursor: pointer;
}

.footer .left button {
  background: #1e90ff;
  color: #fff;
}

.footer .right button.bg-red-600 {
  background: #dc2626 !important;
  color: #fff !important;
}

.footer .right button.bg-blue-safe {
  background: #1e90ff !important;
  color: #fff !important;
}

/* Scrollbar for dialog content */
.flex.flex-col.gap-4.overflow-auto.min-h-\[10em\] {
  scrollbar-width: thin;
  scrollbar-color: #1e90ff #23262f;
  max-height: 60vh;
  min-height: 10em;
  padding-right: 0.5rem;
}
.flex.flex-col.gap-4.overflow-auto.min-h-\[10em\]::-webkit-scrollbar {
  width: 8px;
}
.flex.flex-col.gap-4.overflow-auto.min-h-\[10em\]::-webkit-scrollbar-thumb {
  background: #1e90ff;
  border-radius: 4px;
}
.flex.flex-col.gap-4.overflow-auto.min-h-\[10em\]::-webkit-scrollbar-track {
  background: #23262f;
}

.content.w-full {
  margin-bottom: 1rem;
}
</style>